define('presentation/settings/billing/plans/facades/removePlanFacade',[
    'externalDependencies/clientWebSocket',
    'persistence/webSocket/webSocketApp',
    'presentation/settings/billing/plans/presentationObjects/planPresentationObject',
], function () {

    const PlanPresentationObjectConstructor = require('presentation/settings/billing/plans/presentationObjects/planPresentationObject');

    const CurrencyFormatterConstructor = require('businessServices/converters/currencyFormatter');
    const _currencyFormatter = new CurrencyFormatterConstructor();

    const clientWebSocket = require('externalDependencies/clientWebSocket');
    const _accountPlanWebSocket = clientWebSocket.forApplication("accountPlan");

    let _promiseFactory = null;
    let _webSocketApp = null;

    const _buildPlanPresentationObject = (billingPackage) => {
        const planPresentationObject = new PlanPresentationObjectConstructor();
        planPresentationObject.billingPackageId = billingPackage.billingPackageId;
        planPresentationObject.packageId = billingPackage.packageId;
        planPresentationObject.name = billingPackage.name;
        planPresentationObject.type(billingPackage.type);
        planPresentationObject.price = _currencyFormatter.formatUSDForDisplay(billingPackage.pricePerMonth);
        planPresentationObject.isActive(true);
        planPresentationObject.isRetired(billingPackage.isRetired);
        planPresentationObject.isOnboardingRequired(billingPackage.isOnboardingRequired);
        return planPresentationObject;
    };

    const _getBillingPackage = (billingPackageId) => {
        return _promiseFactory.deferIndefinitely((promise) => {
            _accountPlanWebSocket.send("getBillingPackageById", { billingPackageId }, (response) => {
                const planPresentationObject = _buildPlanPresentationObject(response);
                promise.resolve(planPresentationObject);
            });
        });
    };

    const _removePlan = ({ billingPackageId, billingPackageType, removePlanFeedback, sendAllCallsTo }) => {
        return _promiseFactory.deferIndefinitely((promise) => {
            _removePlanClientApi(billingPackageId, removePlanFeedback, sendAllCallsTo)
                .fail(promise.reject)
                .done (() => {
                    const request = {
                        packageId: billingPackageId,
                        packageType: billingPackageType
                    };
                    _webSocketApp.send("remove_package", request, (result) => {
                        promise.resolve(result);
                    });
                });
        });
    };

    const _removePlanClientApi = (billingPackageId, removePlanFeedback, sendAllCallsTo) => {
        return _promiseFactory.deferIndefinitely((promise) => {
            const request = {
                billingPackageId,
                removeAccountPackageFeedback: removePlanFeedback,
                sendAllCallsTo: {
                    userId: sendAllCallsTo.subscriberType === "user" ? sendAllCallsTo.subscriberId : null,
                    userGroupId: sendAllCallsTo.subscriberType === "userGroup" ? sendAllCallsTo.subscriberId : null
                }
            };
            _accountPlanWebSocket.send("removeAccountPackage", request, (result, err) => {
                if (err) {
                    promise.reject(new Error(err));
                    return;
                }
                promise.resolve(result);
            });
        });
    };

    const _init = (promiseFactory) => {
        const WebSocketAppConstructor = require('persistence/webSocket/webSocketApp');
        _webSocketApp = new WebSocketAppConstructor();
        _webSocketApp.init("account_plan");

        _promiseFactory = promiseFactory;
    };

    return function () {
        let self = this;

        self.init = _init;
        self.getBillingPackage = _getBillingPackage;
        self.removePlan = _removePlan;
    };
});
